export const MARKETING_DATA_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_id',
    'utm_term',
    'referral',
    'gclid',
    'fbclid',
    'li_fat_id',
    'fbp',
    'userAgent',
] as const;

export type MarketingDataKey = (typeof MARKETING_DATA_KEYS)[number];

export type MarketingData = Partial<Record<MarketingDataKey, string>>;



// WEBPACK FOOTER //
// ./src/webportal/interfaces/MarketingDataInterface.ts